import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "promise"]

  connect() {
    // set initial state
    this.update()
  }

  update() {
    // Whilst there are several checkbox targets we can use the singular case
    // to get the first one, which happens to be where the kittens and puppies are!
    this.promiseTarget.classList.toggle("hidden", !this.checkboxTarget.checked)
  }
}
